/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsControllerGetTokenForProviderQueryResponse, IntegrationsControllerGetTokenForProviderPathParams, IntegrationsControllerGetTokenForProvider404 } from "../../models/integrationsController/IntegrationsControllerGetTokenForProvider";

function getIntegrationsControllerGetTokenForProviderUrl(provider: IntegrationsControllerGetTokenForProviderPathParams["provider"]) {
  const res = { method: 'GET', url: `/api/v1/integrations/${provider}` as const }  
  return res
}

/**
 * @summary Get the current access token for a provider
 * {@link /api/v1/integrations/:provider}
 * @deprecated
 */
export async function integrationsControllerGetTokenForProvider(provider: IntegrationsControllerGetTokenForProviderPathParams["provider"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IntegrationsControllerGetTokenForProviderQueryResponse, ResponseErrorConfig<IntegrationsControllerGetTokenForProvider404>, unknown>({ method : "GET", url : getIntegrationsControllerGetTokenForProviderUrl(provider).url.toString(), ... requestConfig })  
  return res.data
}